export const editProgressPolicy = (order = {}) => {
  const stops = Array.isArray(order.orderStatus) ? order.orderStatus : [];
  const pickupClosed = stops.length >= 3 || stops.some((item) =>
    String(item?.message || '').toLowerCase().includes('pickup closed'));
  const blocked = pickupClosed || ['cancelled', 'canceled', 'delivered', 'completed']
    .includes(String(order.status || '').toLowerCase());
  return {
    blocked,
    parcelLocked: blocked || stops.length >= 2 || stops.some((item) =>
      String(item?.message || '').toLowerCase().includes('arrived at pickup')),
    message: pickupClosed
      ? 'The rider has closed pickup. This order can no longer be edited or cancelled.'
      : 'This order can no longer be edited or cancelled.',
  };
};

// Merge status only. Never replace addresses, parcel values or unsaved inputs.
export const mergeEditProgress = (current, payload, ids) => {
  if (!payload || typeof payload !== 'object') return current;
  const summary = payload.orderSummary || payload;
  if (!ids.includes(String(payload.orderId || summary._id || '')) &&
      !ids.includes(String(summary._id || ''))) return current;
  const stops = summary.orderStatus ?? payload.completedStops;
  const status = summary.status ?? payload.currentStatus;
  if (!Array.isArray(stops) && status == null) return current;
  const timestamp = summary.updatedAt ?? payload.updatedAt;
  const nextTime = Date.parse(timestamp);
  const oldTime = Date.parse(current.updatedAt);
  if (Number.isFinite(oldTime) && (!Number.isFinite(nextTime) || nextTime < oldTime)) return current;
  if (Array.isArray(stops) && stops.length < (current.orderStatus || []).length &&
      (!Number.isFinite(nextTime) || nextTime === oldTime)) return current;
  return { ...current,
    orderStatus: Array.isArray(stops) ? stops : current.orderStatus,
    status: status ?? current.status,
    updatedAt: timestamp ?? current.updatedAt,
  };
};
